/* components/Quiz2.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	globals,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	null_to_empty,
	prevent_default,
	safe_not_equal,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

const { Boolean: Boolean_1 } = globals;
import store from "../store";
import Radio from "./Radio.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-xwqex7-style";
	style.textContent = ".subtitle.svelte-xwqex7.svelte-xwqex7{margin-bottom:24px}.quiz__subtitle.svelte-xwqex7.svelte-xwqex7{font-size:24px}.quiz__title.svelte-xwqex7.svelte-xwqex7{font-size:40px;color:#29ABE2;text-shadow:0 0 26px rgba(41, 171, 226, 0.58)}.quiz__info.svelte-xwqex7 p.svelte-xwqex7{font-size:16px;margin:40px 0 0}.checked .active+.error.svelte-xwqex7.svelte-xwqex7{color:#FF4A4A}.checked .active+.success.svelte-xwqex7.svelte-xwqex7{color:#12BD75}button.svelte-xwqex7.svelte-xwqex7:disabled{opacity:0.2}.checked.svelte-xwqex7 button.svelte-xwqex7:disabled{opacity:1;cursor:default}.checked.svelte-xwqex7 button.error.svelte-xwqex7{border-color:#FF4A4A;color:#FF4A4A}.checked.svelte-xwqex7 button.success.svelte-xwqex7{border-color:#12BD75;color:#12BD75}@media(min-width: 768px){.subtitle.svelte-xwqex7.svelte-xwqex7{margin-bottom:40px}}";
	append(document.head, style);
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (59:6) {:else}
function create_else_block(ctx) {
	let form;
	let h3;
	let t1;
	let t2;
	let button;
	let t3;
	let button_class_value;
	let button_disabled_value;
	let current;
	let mounted;
	let dispose;
	let each_value = /*list*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			form = element("form");
			h3 = element("h3");
			h3.textContent = "Guess how much Dragon worth ETH?";
			t1 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			button = element("button");
			t3 = text("answer");
			attr(h3, "class", "subtitle svelte-xwqex7");
			attr(button, "class", button_class_value = "button " + (/*isCorrectAnswer*/ ctx[2] ? "success" : "error") + " svelte-xwqex7");
			button.disabled = button_disabled_value = !/*group*/ ctx[0] || /*isChecked*/ ctx[1];
			attr(form, "class", "svelte-xwqex7");
			toggle_class(form, "checked", /*isChecked*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, form, anchor);
			append(form, h3);
			append(form, t1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(form, null);
			}

			append(form, t2);
			append(form, button);
			append(button, t3);
			current = true;

			if (!mounted) {
				dispose = listen(form, "submit", prevent_default(/*onSubmit*/ ctx[5]));
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*list, group, answer, isChecked*/ 19) {
				each_value = /*list*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(form, t2);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (!current || dirty & /*isCorrectAnswer*/ 4 && button_class_value !== (button_class_value = "button " + (/*isCorrectAnswer*/ ctx[2] ? "success" : "error") + " svelte-xwqex7")) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*group, isChecked*/ 3 && button_disabled_value !== (button_disabled_value = !/*group*/ ctx[0] || /*isChecked*/ ctx[1])) {
				button.disabled = button_disabled_value;
			}

			if (dirty & /*isChecked*/ 2) {
				toggle_class(form, "checked", /*isChecked*/ ctx[1]);
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean_1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(form);
			destroy_each(each_blocks, detaching);
			mounted = false;
			dispose();
		}
	};
}

// (55:6) {#if isQuizPassed}
function create_if_block(ctx) {
	let h3;
	let t1;
	let div;
	let t3;
	let p;

	return {
		c() {
			h3 = element("h3");
			h3.textContent = "600 ETH";
			t1 = space();
			div = element("div");
			div.textContent = "$170k at time of sale";
			t3 = space();
			p = element("p");
			p.textContent = "It’s a staggering amount of money — enough to buy a house in many parts of the world — and 2,833 times more than the average of $60 that was being paid for CryptoKitties at the time.";
			attr(h3, "class", "quiz__title svelte-xwqex7");
			attr(div, "class", "quiz__subtitle svelte-xwqex7");
			attr(p, "class", "svelte-xwqex7");
		},
		m(target, anchor) {
			insert(target, h3, anchor);
			insert(target, t1, anchor);
			insert(target, div, anchor);
			insert(target, t3, anchor);
			insert(target, p, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h3);
			if (detaching) detach(t1);
			if (detaching) detach(div);
			if (detaching) detach(t3);
			if (detaching) detach(p);
		}
	};
}

// (63:12) <Radio bind:group value={item}>
function create_default_slot(ctx) {
	let span;
	let t_value = /*item*/ ctx[9] + "";
	let t;
	let span_class_value;
	let mounted;
	let dispose;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			attr(span, "class", span_class_value = "" + (null_to_empty(/*item*/ ctx[9] === answer ? "success" : "error") + " svelte-xwqex7"));
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);

			if (!mounted) {
				dispose = listen(span, "click", /*click_handler*/ ctx[6]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

// (62:10) {#each list as item}
function create_each_block(ctx) {
	let radio;
	let updating_group;
	let current;

	function radio_group_binding(value) {
		/*radio_group_binding*/ ctx[7].call(null, value);
	}

	let radio_props = {
		value: /*item*/ ctx[9],
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	if (/*group*/ ctx[0] !== void 0) {
		radio_props.group = /*group*/ ctx[0];
	}

	radio = new Radio({ props: radio_props });
	binding_callbacks.push(() => bind(radio, "group", radio_group_binding));

	return {
		c() {
			create_component(radio.$$.fragment);
		},
		m(target, anchor) {
			mount_component(radio, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const radio_changes = {};

			if (dirty & /*$$scope, isChecked*/ 4098) {
				radio_changes.$$scope = { dirty, ctx };
			}

			if (!updating_group && dirty & /*group*/ 1) {
				updating_group = true;
				radio_changes.group = /*group*/ ctx[0];
				add_flush_callback(() => updating_group = false);
			}

			radio.$set(radio_changes);
		},
		i(local) {
			if (current) return;
			transition_in(radio.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(radio.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(radio, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div5;
	let div2;
	let t1;
	let div4;
	let div3;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*isQuizPassed*/ ctx[3]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div5 = element("div");
			div2 = element("div");

			div2.innerHTML = `<div class="card quiz__img"><div class="quiz__wrap"><img class="quiz__image-mobile lazy" src="https://s3.cointelegraph.com/storage/uploads/view/3f9e9b218b3021f6e9c2cad440dea841.png" alt="Guess how much Dragon worth ETH?"> 
        <img class="quiz__image-desktop lazy" src="https://s3.cointelegraph.com/storage/uploads/view/b36676ee3480fae05db53d274c4e90f7.png" alt="Guess how much Dragon worth ETH?"></div></div>`;

			t1 = space();
			div4 = element("div");
			div3 = element("div");
			if_block.c();
			attr(div2, "class", "quiz__block");
			attr(div3, "class", "card quiz__info svelte-xwqex7");
			attr(div4, "class", "quiz__block");
			attr(div5, "class", "quiz__row");
		},
		m(target, anchor) {
			insert(target, div5, anchor);
			append(div5, div2);
			append(div5, t1);
			append(div5, div4);
			append(div4, div3);
			if_blocks[current_block_type_index].m(div3, null);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(div3, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div5);
			if_blocks[current_block_type_index].d();
		}
	};
}

let answer = "600";

function instance($$self, $$props, $$invalidate) {
	let group;
	let successfullyCompleted;
	let isChecked = false;
	let isCorrectAnswer;
	let isQuizPassed = false;
	let list = ["5", "10", "100", "300", "400", "600"];

	const onSubmit = () => {
		$$invalidate(1, isChecked = true);
		setTimeout(() => $$invalidate(3, isQuizPassed = true), 1000);
	};

	const click_handler = () => $$invalidate(1, isChecked = false);

	function radio_group_binding(value) {
		group = value;
		$$invalidate(0, group);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*group*/ 1) {
			$: $$invalidate(2, isCorrectAnswer = group === answer);
		}

		if ($$self.$$.dirty & /*isQuizPassed, isCorrectAnswer*/ 12) {
			$: $$invalidate(8, successfullyCompleted = Boolean(isQuizPassed && isCorrectAnswer));
		}

		if ($$self.$$.dirty & /*successfullyCompleted*/ 256) {
			$: {
				store.update(storeValues => ({
					...storeValues,
					hasQuiz2SuccessAnswer: successfullyCompleted
				}));
			}
		}
	};

	return [
		group,
		isChecked,
		isCorrectAnswer,
		isQuizPassed,
		list,
		onSubmit,
		click_handler,
		radio_group_binding
	];
}

class Quiz2 extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-xwqex7-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Quiz2;